import apiClient from 'api/base';
import { User, UserRole } from 'models/user.model';

export const getAdmins = async (): Promise<User[]> => {
  const { data } = await apiClient.get('/admins');

  return data;
};

export const getSuperAdmins = async (): Promise<string[]> => {
  const { data } = await apiClient.get('/super-admin-emails');

  return data;
};

export const inviteAdmin = async (
  email: string,
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.post('/admins', { email, role });

  return data;
};

export const inviteAdminInBulk = async (
  emails: string[],
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.post('/admins/bulk', { emails, role });

  return data;
};

export const updateAdminRole = async (
  adminId: string,
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.patch(`/admins/${adminId}/role`, { role });

  return data;
};

export const deleteAdmin = async (adminId: string): Promise<void> => {
  const { data } = await apiClient.delete(`/admins/${adminId}`);

  return data;
};
